//object needs some markAnswer logic

export function markAnswer(): boolean {
  return true;
}
